/**
 * TRACKING GTM version 2026.
 */
(function () {
	var lastEventTimes = {};
	var THROTTLE_DELAY = 60000; // 1 minute in milliseconds

	/**
	 * Envoie un événement au dataLayer, limité à un évenement du même type par minute
	 */
	function pushToDataLayer(data) {
		var eventName = data.event;
		if (!eventName) {
			// If no event name, push without throttling
			window.dataLayer.push(data);
			return true;
		}

		var now = Date.now();
		var lastTime = lastEventTimes[eventName] || 0;

		if (now - lastTime >= THROTTLE_DELAY) {
			lastEventTimes[eventName] = now;
			window.dataLayer.push(data);
			return true;
		}

		return false;
	}

	// Tracking sur toutes les pages
	window.onload = function () {
		dataTracking.env_channel = window.getComputedStyle(
			document.querySelector('html')
		)['z-index'];
		if (dataTracking.env_channel != '') {
			if (dataTracking.env_channel == '1') {
				dataTracking.env_channel = 'mobile';
			} else if (dataTracking.env_channel == '2') {
				dataTracking.env_channel = 'tablet';
			} else if (dataTracking.env_channel == '3') {
				dataTracking.env_channel = 'desktop';
			} else if (dataTracking.env_channel == '4') {
				dataTracking.env_channel = 'wide';
			}
		}

		pushToDataLayer({
			event: 'datalayer-loaded',
			page_type: dataTracking.pageType,
			env_channel: dataTracking.env_channel,
			page_cat: dataTracking.page_cat,
			program_id: dataTracking.program_id,
			promotion_name: dataTracking.promotion_name,
			program_category: dataTracking.program_category,
			program_price_from: dataTracking.program_price_from,
			program_type: dataTracking.program_type,
			program_eligibility: dataTracking.program_eligibility,
			program_localisation: dataTracking.program_localisation,
			'connected-user': dataTracking.is_connected ? '1' : '0',
		});
	};

	// Tracking à chaque validation d'un formulaire WPCF7
	document.addEventListener(
		'wpcf7mailsent',
		function (event) {
			// GET id_source Unlatch from contact form
			var formId = event.detail.contactFormId;
			if(dataTracking.api_leads) {
				var currentForm = dataTracking.api_leads.find((o) => o.formulaire === formId);
				if (currentForm !== undefined) {
					formId = currentForm[dataTracking.current_structure.id_source_reference];
				}
			}

			// Récupération des données utilisateur
			var emailInput = event.detail.inputs.find((o) => o.name === 'your-email');
			var phoneInput = event.detail.inputs.find((o) => o.name === 'your-phone');
			var firstNameInput = event.detail.inputs.find((o) => o.name === 'your-surname');
			var lastNameInput = event.detail.inputs.find((o) => o.name === 'your-name');

			var userData = {
				email: emailInput ? emailInput.value : 'Email non trouvé',
				phone_number: phoneInput ? phoneInput.value : 'Téléphone non trouvé',
				first_name: firstNameInput ? firstNameInput.value : 'Prénom non trouvé',
				last_name: lastNameInput ? lastNameInput.value : 'Nom non trouvé',
			};

			var formDestinataire = event.detail.inputs.find((o) => o.name === 'to');
			if (formDestinataire == undefined) {
				formDestinataire = '';
			} else {
				formDestinataire = formDestinataire.value;
			}

			if (event.detail.contactFormId == dataTracking.contact_document_id) {
				// Formulaire de téléchargement de document
				let docname = event.target.querySelector(
					'input[name*="your-document"]'
				).value;
				let doctype = event.target
					.querySelector('.description-form strong')
					.innerText.trim()
					.toLowerCase();
				doctype = doctype.replace(' par email', '');
				doctype = doctype.replace('télécharger le ', '');
				doctype = doctype.replace('télécharger la ', '');

				pushToDataLayer({
					event: 'doc_download_form',
					form_id: formId,
					doc_name: docname,
					doc_type: doctype,
					program_name: dataTracking.promotion_name,
					destinataire: formDestinataire,
					user_data: userData,
				});
			} else if (event.detail.contactFormId == dataTracking.contact_plan_id) {
				// Formulaire de téléchargement de plan
				let docname = event.target.querySelector(
					'input[name*="your-plan"]'
				).value;
				let doctype = 'plan';

				pushToDataLayer({
					event: 'doc_download_form',
					form_id: formId,
					doc_name: docname,
					doc_type: doctype,
					program_name: dataTracking.promotion_name,
					destinataire: formDestinataire,
					user_data: userData,
				});
			} else if (event.detail.contactFormId == dataTracking.contact_offer_id) {
				// Formulaire d'offre d'emploi
				pushToDataLayer({
					event: 'job-form-success',
					form_id: formId,
					user_data: userData,
				});
			} else {
				// Tous les autres formulaires
				var contactFormTitle = event.target.querySelector('.description-form strong').innerText || 'Titre du formulaire non trouvé';

				if (dataTracking.pageType == 'program' || dataTracking.pageType == 'land') {
					// Page programme ou terrain
					var lotReferenceInput = event.target.querySelector('input[name*="lot-reference"]');
					var lotReference = lotReferenceInput ? lotReferenceInput.value : '';

					var datasArr = {
						event: '',
						form_id: formId,
						contact_type: contactFormTitle,
						destinataire: formDestinataire,
						type_of_project: 'Habiter',
						contact_currency: 'EUR',
						product: [{
							program_name: dataTracking.promotion_name,
							apartment_quantity: '1',
							program_localisation: dataTracking.program_localisation,
						}],
						user_data: userData,
					};

					let typeAchat = event.target.querySelector(
						'input[name*="type-acquisition"]:checked'
					);
					if (typeAchat != null && typeof typeAchat != 'undefined') {
						datasArr.type_of_project = 'Pour ' + typeAchat.value;
					}

					if (lotReference != '') {
						// Si on est sur une demande de contact LOT
						const lotContext = window.dataLayer.find(item => item.lot_context);
						if (lotContext) {
							// Si le contexte custom existe
							datasArr.property_id = lotContext.lot_context.reference;
							datasArr.property_name = lotContext.lot_context.name;
							datasArr.property_price = lotContext.lot_context.price;
						} else {
							var lotPrice = event.target.querySelector('input[name*="lot-price"]').value;
							datasArr.property_id = event.target.querySelector('input[name*="lot-id"]').value;
							datasArr.property_name = lotReference != '' ? lotReference.split(': ')[1] : '';
							datasArr.property_price = lotPrice;
						}

						if (event.detail.contactFormId == dataTracking.contact_message_id) {
							// Formulaire de contact par mail sur lot spécifique
							datasArr.event = 'property_contact_form_success';
						} else if (event.detail.contactFormId == dataTracking.contact_rappel_id) {
							// Formulaire de demande de rappel sur lot spécifique
							datasArr.event = 'property_callback_form_success';
						}
					} else {
						// Si on est sur une demande de contact OPERATION
						if (event.detail.contactFormId == dataTracking.contact_plaquette_id) {
							// Formulaire de demande de plaquette sur page programme
							datasArr.event = 'brochure_download_form';
						} else if (event.detail.contactFormId == dataTracking.contact_message_id) {
							// Formulaire de contact par mail sur page programme
							const lotContext = window.dataLayer.find(item => item.lot_context);
							if (lotContext) {
								// Contact depuis un lot spécifique
								datasArr.event = 'property_contact_form_success';
								datasArr.property_id = lotContext.lot_context.reference;
								datasArr.property_name = lotContext.lot_context.name;
								datasArr.property_price = lotContext.lot_context.price;
							} else {
								// Contact général programme
								datasArr.event = 'program_contact_form_success';
							}
						} else if (event.detail.contactFormId == dataTracking.contact_rappel_id) {
							// Formulaire de demande de rappel sur page programme
							const lotContext = window.dataLayer.find(item => item.lot_context);
							if (lotContext) {
								// Rappel depuis un lot spécifique
								datasArr.event = 'property_callback_form_success';
								datasArr.property_id = lotContext.lot_context.reference;
								datasArr.property_name = lotContext.lot_context.name;
								datasArr.property_price = lotContext.lot_context.price;
							} else {
								// Rappel général programme
								datasArr.event = 'program_callback_form_success';
							}
						}

						datasArr.contact_price_from = dataTracking.program_price_from;
						datasArr.product[0].program_id = dataTracking.program_id;
						datasArr.product[0].program_type = dataTracking.program_type;
						datasArr.product[0].program_price_from = dataTracking.program_price_from;
						datasArr.product[0].program_eligibility = dataTracking.program_eligibility;
					}

					pushToDataLayer(datasArr);
				} else {
					let datasArr = {
						form_id: formId,
						contact_type: contactFormTitle,
						destinataire: formDestinataire,
						type_of_project: 'Habiter',
						user_data: userData,
					};

					if (event.detail.contactFormId == dataTracking.contact_message_id) {
						// Formulaire de contact par mail hors page programme
						datasArr.event = 'generic_contact_form_success';
					} else if (event.detail.contactFormId == dataTracking.contact_rappel_id) {
						// Formulaire de demande de rappel hors page programme
						datasArr.event = 'generic_callback_form_success';
					}

					let typeAchat = event.target.querySelector(
						'input[name*="type-acquisition"]:checked'
					);
					if (typeAchat != null && typeof typeAchat != 'undefined') {
						datasArr.type_of_project = 'Pour ' + typeAchat.value;
					}

					pushToDataLayer(datasArr);
				}
			}
		},
		false
	);

	// Tracking a chaque recherche simple
	document.addEventListener('click', function (event) {
		const search_button = document.querySelector(
			'form.searchform--main .searchform__button'
		);

		if (search_button == null || typeof search_button == 'undefined') {
			return;
		}

		if (
			event.target == search_button ||
			event.target.closest('.searchform--main .searchform__button') ==
			search_button
		) {
			let form = search_button.closest('form');
			let typology = form.querySelector('select[name="typology[]"]');
			let typologyValues = [];
			if (typology != null && typeof typology != 'undefined') {
				for (let i = 0; i < typology.options.length; i++) {
					if (typology.options[i].selected) {
						typologyValues.push(typology.options[i].value);
					}
				}
			}
			if (typologyValues.length == 0) {
				typologyValues = 'Non renseigné';
			}

			let isInvest = form.querySelector('input[name="is_invest"]');
			let isInvestValue = 'Non renseigné';
			if (isInvest != null && typeof isInvest != 'undefined' && isInvest.value != '') {
				isInvestValue = isInvest.value == '1' ? 'Investir' : 'Habiter';
			}

			let price_max = form.querySelector('input[name="price_max"]');
			if(price_max == null || price_max.value == '') {
				price_max = 0;
			} else {
				price_max = parseInt(price_max.value);
			}
			let fourchette_prix_max = definePriceRange(price_max);

			let zone = form.querySelector('input[name="zone"]');
			if (zone == null || zone.value == '' || zone.value == 'Dernière recherche') {
				zone = 'Toutes';
			} else {
				zone = zone.value;
			}

			let data = {
				event: 'recherche',
				type_achat: isInvestValue,
				type_bien: typologyValues,
				zone_geographique: zone,
				prix_max: fourchette_prix_max,
			};

			if (document.body.classList.contains('lotisseur')) {
				delete data.type_bien;
				data.surface_min = defineSurfaceRange(parseInt(form.querySelector('input[name="surface_min"]').value), 'lotisseur');
			}

			pushToDataLayer(data);
		}
	});

	// Tracking à chaque recherche avancée
	document.addEventListener('click', function (event) {
		const search_button = document.querySelector(
			'.searchform--expand .searchform__button'
		);

		if (search_button == null || typeof search_button == 'undefined') {
			return;
		}

		if (
			event.target == search_button ||
			event.target.closest('.searchform--expand .searchform__button') ==
			search_button
		) {
			let form = search_button.closest('form');
			let data = { event: 'recherche_avancee' };
			let batiType = 'promoteur';

			if (document.body.classList.contains('lotisseur')) {
				batiType = 'lotisseur';
				// libre_de_constructeur
				let isFreeManufacturer = form.querySelectorAll(
					'input[name="free_manufacturer"]'
				);
				let isFreeManufacturerValue = 'Non renseigné';
				isFreeManufacturer.forEach((input) => {
					if (input.checked) {
						isFreeManufacturerValue = input.value == '1' ? 'Oui' : 'Non';
					}
				});

				// terrain_viabilise
				let isViabilise = form.querySelectorAll('input[name="viabilise"]');
				let isViabiliseValue = 'Non renseigné';
				isViabilise.forEach((input) => {
					if (input.checked) {
						isViabiliseValue = input.value == '1' ? 'Oui' : 'Non';
					}
				});

				let rayon = form.querySelectorAll('input[name="radius"]');
				let rayonValue = 'Non renseigné';
				rayon.forEach((input) => {
					if (input.checked) {
						rayonValue = input.value + ' km';
					}
				});

				data.rayon = rayonValue;
				data.libre_de_constructeur = isFreeManufacturerValue;
				data.terrain_viabilise = isViabiliseValue;
				data.offre_terrain_maison = 'Non renseigné';
			} else {
				let pieces = form.querySelectorAll('input[name="piece_number[]"]');
				let piecesValues = [];
				//as typologies are cheboxes, we need to loop through all options
				pieces.forEach((piece) => {
					if (piece.checked) {
						piecesValues.push(piece.value);
					}
				});

				if (piecesValues.length == 0) {
					piecesValues = 'Non renseigné';
				}

				let fiscals = form.querySelectorAll('input[name="fiscal[]"]');
				let fiscalsValues = [];
				//as typologies are cheboxes, we need to loop through all options
				fiscals.forEach((fiscal) => {
					if (fiscal.checked) {
						fiscalsValues.push(defineFiscalLabel(fiscal.value));
					}
				});

				if (fiscalsValues.length == 0) {
					fiscalsValues = 'Non renseigné';
				}

				let typologies = form.querySelectorAll('input[name="typology[]"]');
				let typologyValues = [];
				//as typologies are cheboxes, we need to loop through all options
				typologies.forEach((typology) => {
					if (typology.checked) {
						typologyValues.push(typology.value);
					}
				});

				if (typologyValues.length == 0) {
					typologyValues = 'Non renseigné';
				}

				data.type_bien = typologyValues;
				data.nombre_pieces = piecesValues;
				data.dispositif_fiscaux = fiscalsValues;
			}

			let isInvest = form.querySelector('input[name="is_invest"]');
			let isInvestValue;
			if (isInvest == null || typeof isInvest == 'undefined') {
				isInvestValue = 'Non renseigné';
			} else {
				isInvestValue = isInvest.checked ? 'Investir' : 'Habiter';
			}

			let price_min = form.querySelector('input[name="price_min"]');
			let fourchette_prix_min = definePriceRange(parseInt(price_min.value), batiType);

			let price_max = form.querySelector('input[name="price_max"]');
			let fourchette_prix_max = definePriceRange(parseInt(price_max.value), batiType);

			let surface_min = form.querySelector('input[name="surface_min"]');
			let fourchette_surface_min = defineSurfaceRange(
				parseInt(surface_min.value),
				batiType
			);

			let surface_max = form.querySelector('input[name="surface_max"]');
			let fourchette_surface_max = defineSurfaceRange(
				parseInt(surface_max.value),
				batiType
			);

			let zone = form.querySelector('input[name="zone"]').value;
			if (zone == '' || zone == 'Dernière recherche') {
				zone = 'Toutes';
			}

			data.zone_geographique = zone;
			data.type_achat = isInvestValue;
			data.prix_min = fourchette_prix_min;
			data.prix_max = fourchette_prix_max;
			data.surface_min = fourchette_surface_min;
			data.surface_max = fourchette_surface_max;

			pushToDataLayer(data);
		}
	});

	function definePriceRange(price, type) {
		if (type == 'lotisseur') {
			switch (true) {
				case price == '':
					return 'Non renseigné';
				case price < 50000:
					return 'Moins de 50 000€';
				case price < 70000:
					return '50 000€ à 70 000€';
				case price < 90000:
					return '70 000€ à 90 000€';
				case price < 120000:
					return '90 000€ à 120 000€';
				case price < 150000:
					return '120 000€ à 150 000€';
				case price < 200000:
					return '150 000€ à 200 000€';
				case price < 250000:
					return '200 000€ à 250 000€';
				default:
					return '250 000€ et plus';
			}
		}

		switch (true) {
			case price == '':
				return 'Non renseigné';
			case price < 100000:
				return 'Moins de 100 000€';
			case price < 150000:
				return '100 000€ à 150 000€';
			case price < 200000:
				return '150 000€ à 200 000€';
			case price < 250000:
				return '200 000€ à 250 000€';
			case price < 300000:
				return '250 000€ à 300 000€';
			case price < 350000:
				return '300 000€ à 350 000€';
			case price < 400000:
				return '350 000€ à 400 000€';
			case price < 450000:
				return '400 000€ à 450 000€';
			case price < 500000:
				return '450 000€ à 500 000€';
			default:
				return '500 000€ et plus';
		}
	}

	function defineSurfaceRange(surface, type) {
		if (type == 'lotisseur') {
			switch (true) {
				case surface == '':
					return 'Non renseigné';
				case surface < 300:
					return 'Moins de 300m²';
				case surface < 400:
					return '300m² à 400m²';
				case surface < 500:
					return '400m² à 500m²';
				default:
					return 'Plus de 500m²';
			}
		}
		switch (true) {
			case surface == '':
				return 'Non renseigné';
			case surface < 20:
				return 'Moins de 20m²';
			case surface < 35:
				return '20m² à 35m²';
			case surface < 50:
				return '35m² à 50m²';
			case surface < 65:
				return '50m² à 65m²';
			case surface < 80:
				return '65m² à 80m²';
			case surface < 95:
				return '80m² à 95m²';
			default:
				return '95m² et plus';
		}
	}

	function defineFiscalLabel(fiscal) {
		switch (fiscal) {
			case 'taux_zero':
				return 'Prêt à taux zéro';
			case 'TVA-5-5':
				return 'TVA réduite 5,5%';
			case 'Primo-Accedant':
				return 'Primo accédant';
			case 'ANRU':
				return 'Zone ANRU';
			case 'Accession-maitrisé':
				return 'Accession maitrisée';
			case 'Loi Pinel':
				return 'Pinel';
			case 'pinel +':
				return 'Pinel plus';
			case 'lmnp':
				return 'LMP/LMNP';
			case 'Nue-propriété':
				return 'Nue-propriété';
			default:
				return fiscal;
		}
	}

	// Tracking à chaque click sur le bouton retour d'une page single programme non terminé
	document.addEventListener(
		'click',
		function (event) {
			const yoast_previous_button = document.querySelector('#breadcrumbs a');
			if (
				yoast_previous_button &&
				yoast_previous_button.textContent === '< Retour'
			) {
				// To do : Mettre à jour l'event
				// window.dataLayer.push({
				//     "event": "breadcrumbs-previous",
				// });
			}
		},
		false
	);

	// Tracking à chaque click sur un bouton pour afficher un numéro de téléphone
	document.addEventListener('click', function (event) {
		const target = event.target.closest('[data-trk-click-telephone]');
		if (target) {
			var datasArr = {
				phone_number: target.getAttribute('data-trk-click-telephone'),
			};

			// Vérifier si le contact provient d'un lot spécifique
			const lotContext = window.dataLayer.find(item => item.lot_context);
			if (lotContext && (dataTracking.pageType == 'program' || dataTracking.pageType == 'land')) {
				datasArr.event = 'property_show_phone_number';
				datasArr.property_id = lotContext.lot_context.reference;
				datasArr.property_name = lotContext.lot_context.name;
				datasArr.property_price = lotContext.lot_context.price;
			} else if (dataTracking.pageType == 'program' || dataTracking.pageType == 'land') {
				datasArr.event = 'program_show_phone_number';
			} else {
				const isInFooter = target.closest('footer') !== null;

				datasArr.event = 'generic_show_phone_number';
				datasArr.location = isInFooter ? 'footer' : 'not-footer';
			}

			pushToDataLayer(datasArr);
		}
	});

	// Tracking à chaque click sur "voir un logement" sur une page programme
	document.addEventListener('click', function (event) {
		const target = event.target.closest('[data-trk-voir-lot]');
		if (target && (dataTracking.pageType == 'program' || dataTracking.pageType == 'land')) {
			pushToDataLayer({
				event: 'click_see_accommodation',
				property_id: target.getAttribute('data-lotreference'),
				property_name: target.getAttribute('data-lotname'),
				property_price: target.getAttribute('data-lotprix'),
			});
		}
	});

	// Tracking à chaque click sur le téléchargement de plan ou plan 3D sur une page programme
	document.addEventListener('click', function (event) {
		const target = event.target.closest('a[target="plan"], a[target="vue"], a[data-trk-document]');
		if (target && (dataTracking.pageType == 'program' || dataTracking.pageType == 'land')) {
			pushToDataLayer({ event: 'brochure_download_click' });
		}
	});

	// Tracking à chaque clic sur le bouton "prendre un rendez-vous"
	document.addEventListener('click', function (event) {
		const target = event.target.closest('a[data-is-make-appointment="true"]');
		if (target) {
			const datasArr = {};
			if (dataTracking.pageType == 'program' || dataTracking.pageType == 'land') {
				const lotContext = window.dataLayer.find(item => item.lot_context);
				if (lotContext) {
					datasArr.event = 'property_make_appointment';
					datasArr.property_id = lotContext.lot_context.reference;
					datasArr.property_name = lotContext.lot_context.name;
					datasArr.property_price = lotContext.lot_context.price;
				} else {
					datasArr.event = 'program_make_appointment';
				}
			} else {
				datasArr.event = 'generic_make_appointment';
			}
			
			pushToDataLayer(datasArr);
		}
	});
})();
